import { gainwix_icons } from "api/ApiConfig";

import crmDelete from "./crm-delete.svg"
import crmUpdate from "./crm-update.svg"

export const ICONSS = {
  gainwixLogo: `${gainwix_icons}/assets/gainwix-images/gainwix-logo.svg`,
  sidenav: `${gainwix_icons}/assets/gainwix-images/sidenav.svg`,
  homeSelected: `${gainwix_icons}/assets/ui/selected-home.svg`,
  campaignSelected: `${gainwix_icons}/assets/ui/selected-campaign.svg`,
  calendarSelected: `${gainwix_icons}/assets/ui/selcected-calendar.svg`,
  inboxSelected: `${gainwix_icons}/assets/ui/selected-inbox.svg`,
  crmSelected: `${gainwix_icons}/assets/ui/selected-crm.svg`,
  channelSelected: `${gainwix_icons}/assets/ui/selected-channel.svg`,
  logout: `${gainwix_icons}/assets/gainwix-images/logout.svg`,
  profileBoy: `${gainwix_icons}/assets/gainwix-images/profile-boy.svg`,
  helpSupport: `${gainwix_icons}/assets/gainwix-images/helpSupport.svg`,
  notifications: `${gainwix_icons}/assets/gainwix-images/notifications.svg`,
  settingSelected: `${gainwix_icons}/assets/gainwix-images/selected-setting.svg`,
  profile: `${gainwix_icons}/assets/gainwix-images/profile.svg`,

  // sign up
  friend_user: `${gainwix_icons}/assets/gainwix-images/friend_user.svg`,
  website: `${gainwix_icons}/assets/gainwix-images/website.svg`,

  //header-dropdown
  freePlan: `${gainwix_icons}/assets/ui/free-plan.svg`,
  starterPlan: `${gainwix_icons}/assets/ui/starter-plan.svg`,
  magnumPlan: `${gainwix_icons}/assets/ui/magnum-plan.svg`,
  growthPlan: `${gainwix_icons}/assets/ui/growth-plan.svg`,

  //account-center

  brandLogo: `${gainwix_icons}/assets/gainwix-images/brand-info-profile.svg`,

  switchAccount: `${gainwix_icons}/assets/gainwix-images/siwtch-account.svg`,
  starterActionIcon: `${gainwix_icons}/assets/gainwix-images/starter-action.svg`,
  starterPlanIcon: `${gainwix_icons}/assets/gainwix-images/starter-plan.svg`,
  growthVerify: `${gainwix_icons}/assets/gainwix-images/growth-verification.svg`,
  magnumPlanIcon: `${gainwix_icons}/assets/gainwix-images/magnum-plan.svg`,
  conversationCredits: `${gainwix_icons}/assets/gainwix-images/conversation-credits.svg`,
  businessVerification: `${gainwix_icons}/assets/gainwix-images/business-verification.svg`,
  paymentMethod: `${gainwix_icons}/assets/gainwix-images/payment-method.svg`,
  creditMarketing: `${gainwix_icons}/assets/gainwix-images/credits-marketing.svg`,
  creditUtility: `${gainwix_icons}/assets/gainwix-images/credits-utility.svg`,
  creditAuthentication: `${gainwix_icons}/assets/gainwix-images/credits-authentication.svg`,
  creditService: `${gainwix_icons}/assets/gainwix-images/credits-services.svg`,
  dotStyleIcon: `${gainwix_icons}/assets/gainwix-images/dot-style.svg`,
  billingHistory: `${gainwix_icons}/assets/gainwix-images/billing-history.svg`,
  starterVerify: `${gainwix_icons}/assets/gainwix-images/starter-verify.svg`,
  starterVerifyication: `${gainwix_icons}/assets/gainwix-images/starter-verification.svg`,
  growthPlanIcon: `${gainwix_icons}/assets/gainwix-images/growth-plan.svg`,
  magnumVerify: `${gainwix_icons}/assets/gainwix-images/magnum-verification.svg`,
  alertRole: `${gainwix_icons}/assets/gainwix-images/alert-role.svg`,
  members: `${gainwix_icons}/assets/gainwix-images/members.svg`,
  creditUsage: `${gainwix_icons}/assets/gainwix-images/credit-usage.svg`,
  debitUsage: `${gainwix_icons}/assets/gainwix-images/debit-usage.svg`,

  // account-brands
  timeCircle: `${gainwix_icons}/assets/gainwix-images/time-circle.svg`,
  inactive_brand: `${gainwix_icons}/assets/gainwix-images/inactive_brands.svg`,

  removeUser: `${gainwix_icons}/assets/gainwix-images/remove-user.svg`,
  accountOwnerPriority: `${gainwix_icons}/assets/gainwix-images/account-owners-priority.svg`,
  verifiedTick: `${gainwix_icons}/assets/gainwix-images/verified-tick.svg`,
  changeRole: `${gainwix_icons}/assets/gainwix-images/change-role.svg`,
  roleSuccessIcon: `${gainwix_icons}/assets/gainwix-images/role-success.svg`,

  razorPay: `${gainwix_icons}/assets/gainwix-images/razorpay.svg`,
  creditsSideBar: `${gainwix_icons}/assets/gainwix-images/credits-sidebar.svg`,
  stoppedIcon: `${gainwix_icons}/assets/gainwix-images/stopped.svg`,

  // CRM
  UploadingIcon: `${gainwix_icons}/assets/gainwix-images/successful-animation.svg`,
  successfulIcon: `${gainwix_icons}/assets/gainwix-images/successfull-icon.svg`,

  // Channels
  stars: `${gainwix_icons}/assets/gainwix-images/Stars.svg`,

  inboxMin: `${gainwix_icons}/assets/gainwix-images/inbox-min.svg`,

  crmDelete: crmDelete,
  crmUpdate: crmUpdate,
};
